import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    container: 'space-y-2 <md:(w-full bg-transparent) md:-mx-8 lg:space-y-4',
    containerWidth: 'md:max-w-2/3',
    containerWrapper: 'w-full flex container md:(px-12 py-8)'
  },
} satisfies CMSConfig['imageBanner']
